var map = {
	"./easy.png": 3601,
	"./hard.png": 3602,
	"./onlevel.png": 3603
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 702;



//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/reading-levels .\.png*
// module id = 702
// module chunks = 0